<template>
  <div>
    <PageHeader>
      <template v-slot:header>{{ challengeGoalTitle }}</template>
    </PageHeader>

    <v-row>
      <v-col cols="3" class="pt-0 pb-0 pl-3 pr-2">
        <FormInputComponent
          label="タイトル"
          type="string"
          v-model="challengeGoalTitle"
          v-bind:disabled="!isEdit"
        />
      </v-col>
      <v-col cols="9" class="pt-4 pb-0 pl-0 pr-0">
        <p>
          <span style="margin-right: 15px">ウェイト合計</span>&nbsp;
          <strong style="color: red">{{ totalWeight }}</strong
          >&nbsp;／&nbsp;
          <strong>{{ currentWeight }}</strong>
          <span v-if="totalWeight != currentWeight" style="margin-left: 20px"
            ><strong style="color: red"
              >※合計点数が一致してません。</strong
            ></span
          >
          <span v-if="totalWeight == currentWeight" style="margin-left: 20px"
            ><strong style="color: blue"
              >※合計点数が一致してます。</strong
            ></span
          >
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-4 pl-3 pr-3">
        <v-col cols="12" class="pa-0">
          <quillEditor
            ref="myQuillEditor1"
            v-model="challengeGoalGuide"
            :options="editorOption"
            v-bind:disabled="!isEdit"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0 pb-0 pl-3 pr-0">
        <Button
          class="mr-2"
          v-if="challengeGoalTitle != challengeGoalTitleInit"
          @click="change_confirm_title()"
          color="primary"
          >タイトル更新</Button
        >
        <Button
          class="mr-2"
          v-if="challengeGoalGuide != challengeGoalGuideInit"
          @click="change_confirm_guide()"
          color="primary"
          absolute
          left
          >凡例更新</Button
        >
        <Button v-if="isEdit" @click="edit()" color="info">新規追加</Button>
      </v-col>
      <!--
      <v-col
        v-if="challengeGoalGuide != challengeGoalGuideInit"
        class="pt-0 pb-0 pl-7 pr-0"
      >
        <Button
          v-if="isEdit"
          @click="change_confirm_guide()"
          color="primary"
          absolute
          left
          >凡例更新</Button
        >
      </v-col>
      <v-col class="pt-0 pb-0 pl-3 pr-0">
        <Button v-if="isEdit" @click="edit()" color="info">新規追加</Button>
      </v-col>
      -->
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          @click:row="edit"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="チャレンジ目標は見つかりませんでした。新規追加ボタンよりチャレンジ目標を設定してください。"
        >
          <template v-slot:[`item.CHG_GOAL_CONTENT`]="{ item }">
            <p
              style="padding: 16px 5px 0px 0px"
              v-html="item.CHG_GOAL_CONTENT"
            ></p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      ref="confirm"
      :title="challengeGoalTitleMsg"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="changeEvaluationInfo"
    >
    </ConfirmDialog>
    <DialogMessage ref="dialog" />

    <ChallengeTargetEdit ref="edit" @edit="editEvaluationInfo" />
  </div>
</template>

<script>
import ChallengeTargetEdit from './GradeChallengeTargetEdit.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import message from '../../../message.js';
import axios from 'axios';
import config from '../../../const.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '../../../common.js';
export default {
  components: {
    ChallengeTargetEdit,
    quillEditor,
    ConfirmDialog,
  },
  props: {
    goalId: {
      type: String,
      required: true,
    },
    gradeId: {
      type: String,
      required: true,
    },
    periodStatus: {
      type: [String, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      confirm: false,
      currentWeight: 0,
      totalWeight: 0,
      challengeGoalTitle: '',
      challengeGoalTitleInit: '',
      challengeGoalTitleMsg: '',
      challengeGoalGuide: '',
      challengeGoalGuideInit: '',
      evalStatus: '',
      isEdit: false,
      isTitleUpdate: false,
      confirmMessage: null,
      userInfo: {},
      items: [],
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            { color: ['red', 'blue', 'deeppink'] },
            'bold',
            'underline',
            'clean',
          ],
        },
        placeholder: 'チャレンジ目標の凡例を入力してください。',
      },
      headers: [
        {
          text: '表示順',
          value: 'ORDER',
        },
        {
          text: 'チャレンジ目標',
          value: 'CHG_GOAL_CONTENT',
        },
        {
          text: '目標数',
          align: 'right',
          value: 'CHG_GOAL_GOAL_VAL',
          width: '10%',
        },
        {
          text: 'ウェイト',
          align: 'right',
          value: 'CHG_GOAL_WEIGHT',
          width: '10%',
        },
      ],
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    // 活性・非活性制御
    this.isEdit = false;
    if (
      this.periodStatus == config.PERIOD_STATUS_BEFORE_GOAL ||
      this.periodStatus == config.PERIOD_STATUS_MAKE_GOAL
    ) {
      // 年度の状態が「0:目標作成前」、「1:目標作成」の場合に活性
      this.isEdit = true;
    }

    this.getEvaluationItems();
  },
  methods: {
    editEvaluationInfo() {
      // 評価情報取得
      this.getEvaluationItems();
    },
    change_confirm_title() {
      this.isTitleUpdate = false;
      // タイトル
      if (!this.challengeGoalTitle) {
        this.$refs.dialog.open(
          'info',
          'タイトルが未入力です。タイトルを入力してください。'
        );
        return;
      }
      this.isTitleUpdate = true;
      // 確認ダイアログ表示
      this.confirmMessage =
        this.challengeGoalTitle + 'のタイトルを更新しますか？';
      this.$refs.confirm.open();
    },
    change_confirm_guide() {
      this.isTitleUpdate = false;
      // 凡例
      if (!this.challengeGoalGuide) {
        this.$refs.dialog.open(
          'info',
          '凡例が未入力です。凡例を入力してください。'
        );
        return;
      }
      // 確認ダイアログ表示
      this.confirmMessage = this.challengeGoalTitle + 'の凡例を更新しますか？';
      this.$refs.confirm.open();
    },
    changeEvaluationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.isTitleUpdate) {
        // タイトル更新
        this.changeChallengeTitleRequest();
      } else {
        // 凡例更新
        this.changeChallengeGuideRequest();
      }
    },
    changeChallengeTitleRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- チャレンジ目標設定タイトル更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/challenge/title/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            CHALLENGE_GOAL_TITLE: this.challengeGoalTitle,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            this.challengeGoalTitleInit = this.challengeGoalTitle;
            this.challengeGoalTitleMsg =
              this.challengeGoalTitle + config.MESSAGE_EDIT;
            msgStr = this.challengeGoalTitle + 'のタイトル更新が成功しました。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    changeChallengeGuideRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- チャレンジ目標設定タイトル更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/challenge/guide/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            CHALLENGE_GOAL_GUIDE: this.challengeGoalGuide,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            this.challengeGoalGuideInit = this.challengeGoalGuide;
            msgStr = this.challengeGoalTitle + 'の凡例更新が成功しました。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    edit(item) {
      // 編集OKの場合のみ処理を行う
      if (!this.isEdit) {
        return;
      }

      var updateFlg = false;
      var groupId = 0;
      var chgGoalContent = '';
      var chgGoalGoalVal = 0;
      var chgGoalWeight = 0;

      if (item != null) {
        updateFlg = true;
        groupId = item.ORDER;
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].ORDER == groupId) {
            chgGoalContent = this.items[i].CHG_GOAL_CONTENT;
            chgGoalGoalVal = this.items[i].CHG_GOAL_GOAL_VAL;
            chgGoalWeight = this.items[i].CHG_GOAL_WEIGHT;
          }
        }
      } else {
        if (this.items.length >= 4) {
          // チャレンジ目標が4つ入力されている場合は処理終了
          this.$refs.dialog.open('info', message.MSG_INFO_CHG_ENTRY_NG);
          return;
        }
        updateFlg = false;
        var isGoal1 = true;
        var isGoal2 = true;
        var isGoal3 = true;
        var isGoal4 = true;

        // チャレンジ目標1の存在チェック
        for (var cnt1 = 0; cnt1 < this.items.length; cnt1++) {
          if (this.items[cnt1].ORDER == 1) {
            isGoal1 = false;
          }
        }
        // チャレンジ目標2の存在チェック
        for (var cnt2 = 0; cnt2 < this.items.length; cnt2++) {
          if (this.items[cnt2].ORDER == 2) {
            isGoal2 = false;
          }
        }
        // チャレンジ目標3の存在チェック
        for (var cnt3 = 0; cnt3 < this.items.length; cnt3++) {
          if (this.items[cnt3].ORDER == 3) {
            isGoal3 = false;
          }
        }
        // チャレンジ目標4の存在チェック
        for (var cnt4 = 0; cnt4 < this.items.length; cnt4++) {
          if (this.items[cnt4].ORDER == 4) {
            isGoal4 = false;
          }
        }
        // GROUP_IDの決定
        if (isGoal1) {
          groupId = 1;
        } else if (isGoal2) {
          groupId = 2;
        } else if (isGoal3) {
          groupId = 3;
        } else if (isGoal4) {
          groupId = 4;
        }
      }

      this.$refs.edit.open(
        this.goalId,
        this.gradeId,
        groupId,
        chgGoalContent,
        chgGoalGoalVal,
        chgGoalWeight,
        updateFlg,
        this.challengeGoalTitle
      );
    },
    async getEvaluationItems() {
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.gradeId
        )
        .then((response) => {
          // タイトル
          this.challengeGoalTitle = response.data[0].CHALLENGE_GOAL_TITLE;
          this.challengeGoalTitleInit = this.challengeGoalTitle;
          this.challengeGoalTitleMsg =
            this.challengeGoalTitle + config.MESSAGE_EDIT;
          // 凡例
          var guide = response.data[0].CHALLENGE_GOAL_GUIDE;
          if (guide == config.GOAL_EMPTY_STRING) {
            this.challengeGoalGuide = '';
          } else {
            this.challengeGoalGuide = guide;
          }
          this.challengeGoalGuideInit = this.challengeGoalGuide;
          // 状態
          this.evalStatus = response.data[0].EVAL_STATUS;

          this.currentWeight = Number(response.data[0].CHALLENGE_GOAL_RATE);
          this.totalWeight = 0;

          this.items = [];

          // 目標データ取得
          if (response.data[0].CHG_GOAL_1_CONTENT != config.GOAL_EMPTY_STRING) {
            // チャレンジ目標1
            var chgGoal1 = {
              ORDER: 1,
              CHG_GOAL_CONTENT: response.data[0].CHG_GOAL_1_CONTENT,
              CHG_GOAL_GOAL_VAL: Number(response.data[0].CHG_GOAL_1_GOAL_VAL),
              CHG_GOAL_WEIGHT: Number(response.data[0].CHG_GOAL_1_WEIGHT),
            };
            this.totalWeight =
              this.totalWeight + Number(response.data[0].CHG_GOAL_1_WEIGHT);
            this.items.push(chgGoal1);
          }
          if (response.data[0].CHG_GOAL_2_CONTENT != config.GOAL_EMPTY_STRING) {
            // チャレンジ目標2
            var chgGoal2 = {
              ORDER: 2,
              CHG_GOAL_CONTENT: response.data[0].CHG_GOAL_2_CONTENT,
              CHG_GOAL_GOAL_VAL: Number(response.data[0].CHG_GOAL_2_GOAL_VAL),
              CHG_GOAL_WEIGHT: Number(response.data[0].CHG_GOAL_2_WEIGHT),
            };
            this.totalWeight =
              this.totalWeight + Number(response.data[0].CHG_GOAL_2_WEIGHT);
            this.items.push(chgGoal2);
          }
          if (response.data[0].CHG_GOAL_3_CONTENT != config.GOAL_EMPTY_STRING) {
            // チャレンジ目標3
            var chgGoal3 = {
              ORDER: 3,
              CHG_GOAL_CONTENT: response.data[0].CHG_GOAL_3_CONTENT,
              CHG_GOAL_GOAL_VAL: Number(response.data[0].CHG_GOAL_3_GOAL_VAL),
              CHG_GOAL_WEIGHT: Number(response.data[0].CHG_GOAL_3_WEIGHT),
            };
            this.totalWeight =
              this.totalWeight + Number(response.data[0].CHG_GOAL_3_WEIGHT);
            this.items.push(chgGoal3);
          }
          if (response.data[0].CHG_GOAL_4_CONTENT != config.GOAL_EMPTY_STRING) {
            // チャレンジ目標4
            var chgGoal4 = {
              ORDER: 4,
              CHG_GOAL_CONTENT: response.data[0].CHG_GOAL_4_CONTENT,
              CHG_GOAL_GOAL_VAL: Number(response.data[0].CHG_GOAL_4_GOAL_VAL),
              CHG_GOAL_WEIGHT: Number(response.data[0].CHG_GOAL_4_WEIGHT),
            };
            this.totalWeight =
              this.totalWeight + Number(response.data[0].CHG_GOAL_4_WEIGHT);
            this.items.push(chgGoal4);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
  },
};
</script>
